import * as React from 'react';

import { IconPropsType } from 'designSystem/types/icons';

interface IChevronDownProps extends IconPropsType {}

const ChevronDownIcon = ({
  size = 24,
  stroke = '#737373',
  ...props
}: IChevronDownProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 9L12 17L4 9"
      stroke={stroke}
      strokeWidth={1.5}
      strokeLinecap="square"
    />
  </svg>
);
export default ChevronDownIcon;
